import { appleMapsUrl, googleMapsUrl, telUrl, wazeUrl } from '@shared/maps';
import { appendEnglish } from '@shared/ptEn';
import { AppleMapsIcon, GlobeIcon, GoogleMapsIcon, PhoneIcon, WazeIcon } from './Icons';

type MapActionsProps = {
  address: string;
  lat: number;
  lng: number;
  phone?: string;
  website?: string;
  name?: string;
};

export function MapActions({ address, lat, lng, phone, website, name }: MapActionsProps) {
  return (
    <div className="action-row" role="group" aria-label="Get directions and contact">
      {phone ? (
        <a className="action-btn" href={telUrl(phone)} aria-label={name ? appendEnglish(`Call ${name}`, name) : `Call ${phone}`}>
          <PhoneIcon width={16} height={16} />
          Call
        </a>
      ) : null}
      {website ? (
        <a className="action-btn" href={website} target="_blank" rel="noreferrer" aria-label="Open website">
          <GlobeIcon width={16} height={16} />
          Website
        </a>
      ) : null}
      <a className="action-btn" href={appleMapsUrl(address)} target="_blank" rel="noreferrer" aria-label="Directions in Apple Maps">
        <AppleMapsIcon width={16} height={16} />
        Apple Maps
      </a>
      <a className="action-btn" href={googleMapsUrl(address)} target="_blank" rel="noreferrer" aria-label="Directions in Google Maps">
        <GoogleMapsIcon width={16} height={16} />
        Google Maps
      </a>
      <a className="action-btn" href={wazeUrl(lat, lng)} target="_blank" rel="noreferrer" aria-label="Directions in Waze">
        <WazeIcon width={16} height={16} />
        Waze
      </a>
    </div>
  );
}
